export var shouldShowPreviousArrow = function shouldShowPreviousArrow(_ref) {
  var _ref$currentSlide = _ref.currentSlide,
    currentSlide = _ref$currentSlide === void 0 ? 0 : _ref$currentSlide,
    slider = _ref.slider;
  var _ref2 = slider !== null && slider !== void 0 ? slider : {},
    loop = _ref2.loop;
  if (loop === undefined || loop === false) {
    return currentSlide !== 0;
  }
  if (loop === true) {
    return true;
  }
  return loop.min === undefined || currentSlide > loop.min;
};
//# sourceMappingURL=shouldShowPreviousArrow.js.map